exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".legal{margin-left:2.4rem;margin-right:1.8rem;font-size:.75em}.c-footer{margin:2.1rem auto 0;padding:.5em 0 .25em;-webkit-box-sizing:border-box;box-sizing:border-box}@media (min-width:60em){.c-footer{margin:2.1rem 0 0}}.c-footer__item{display:inline-block;border-left:1px solid #666;padding:0 .35rem}.c-footer__item:first-child{border-left:none;margin-left:.6rem}.c-footer__item:last-child{margin-right:.6rem}.c-footer__item--first{margin-left:.6rem}.c-footer__item--last{margin-right:.6rem}.c-addthis{margin-top:.42rem}", ""]);

// exports
